import React from "react";
import MainMenu from "./MainMenu";


export default function AdminLayout(){
    return (
        <div>
                <div className="person" >
                    <h1><i class="fa fa-cube" aria-hidden="true"></i> Astro 2.0</h1>
                </div>
                <div style={{marginTop:'10px'}}>
                    <MainMenu />
                </div>
        </div>
    )
}
